  <app-cargando *ngIf="cargando"></app-cargando>

  <div class="encabezado" style="margin-top: 30px;">
    <p style="margin: 0px;">Lista de Oportunidades</p>
    <button (click)="exportarExcel()" mat-raised-button style="background: #388E3C;color: white; height: 38px;margin-left: 10px;">
      <i class="fa-duotone fa-file-excel" style="font-size: 18px;"></i> Exportar
    </button>
  </div>

  <button type="button" class="btn boton-crear" (click)="crearOportunidad()">
    Crear Oportunidad
  </button>

  <div class="row">


    <div class="col-12 col-sm-6" style="padding: 5px;" *ngIf="this.login?.ADMIN || this.perfilUsuario.NOMBRE.toLowerCase().includes('pm')">
      <div style="width: 100%;display: flex;justify-content: center;">Vendedor</div>
      <select class="form-control" style="width: 100%;" [(ngModel)]="SLPCODEFILTRO" (change)="filtrarOportunidades()">
        <option value="">Todos</option>
        <option *ngFor="let item of listaVendedor" [value]="item.SlpCode">{{item.SlpName}}</option>
      </select>
    </div>

    <div class="col-12 col-sm-6" style="padding: 5px;" *ngIf="this.login?.ADMIN">
      <div style="width: 100%;display: flex;justify-content: center;">Categoría</div>
      <input type="text" class="form-control" style="width: 100%;" [(ngModel)]="CATEGORIAFILTROOPORTUNIDAD" (keyup)="filtrarOportunidades()">
    </div>

    <div class="col-12 col-sm-6" style="padding: 5px;" *ngIf="!this.login?.ADMIN && this.perfilUsuario.NOMBRE.toLowerCase().includes('pm')">
      <div style="width: 100%;display: flex;justify-content: center;">Categoría</div>
      <input type="text" class="form-control" style="width: 100%;" [(ngModel)]="CATEGORIAFILTROOPORTUNIDAD" (keyup)="filtrarOportunidades()">
    </div>

    <div class="col-12 col-sm-6" style="padding: 5px;">
      <div style="width: 100%;display: flex;justify-content: center;">Desde</div>
      <input type="date" class="form-control" style="width: 100%;" [(ngModel)]="DESDE" (change)="filtrarOportunidades()">
    </div>

    <div class="col-12 col-sm-6" style="padding: 5px;">
      <div style="width: 100%;display: flex;justify-content: center;">Hasta</div>
      <input type="date" class="form-control" style="width: 100%;" [(ngModel)]="HASTA" (change)="filtrarOportunidades()">
    </div>

  </div>

  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center">

    <mat-tab>
      
      <ng-template mat-tab-label>
        <i style="font-size: 25px;" class="fa-duotone fa-list"></i>
      </ng-template>

      <ngx-table class="ngx-table-personalizada" #table [configuration]="configuration" [data]="dataView" [columns]="columns" (event)="abrirOportunidad($event,null)"></ngx-table>

      <ng-template #frmAccion let-row let-rowIndex="rowIndex">
          <a [routerLink]="'/Oportunidad/Detalle/'+row.OpprId">
            <button type="button" class="btn boton-crear" style="font-size: 16px;">
              Abrir
            </button>
          </a>
      </ng-template>

      <ng-template #frmCreateDate let-row let-rowIndex="rowIndex">
          {{row.CreateDate | date:'dd/MM/yyyy'}}
      </ng-template>

      <ng-template #frmPredDate let-row let-rowIndex="rowIndex">
          <input type="date" [(ngModel)]="row.PredDate" (change)="actualizaOportunidad(row)" 
          style="
          background: #444d54;
          color: white;
          border: 1px solid white;
          padding: 5px;
          border-radius: 5px;">
      </ng-template>

      <ng-template #frmCloPrcnt let-row let-rowIndex="rowIndex">
          <div class="progress" *ngIf="row.CloPrcnt <= 25">
            <div class="progress-bar" style="width: 100%;background-color: rgb(221, 65, 65);" [style]="'width: '+row.CloPrcnt+'%'">
              {{row.CloPrcnt}} %
            </div>
          </div>
          <div class="progress" *ngIf="row.CloPrcnt <= 50 && row.CloPrcnt > 25">
            <div class="progress-bar" style="width: 100%;background-color: rgb(244, 215, 50);color: #454D55;" [style]="'width: '+row.CloPrcnt+'%'">
              {{row.CloPrcnt}} %
            </div>
          </div>
          <div class="progress" *ngIf="row.CloPrcnt <= 75 && row.CloPrcnt > 50">
            <div class="progress-bar" style="width: 100%;background-color: rgb(65, 166, 221);" [style]="'width: '+row.CloPrcnt+'%'">
              {{row.CloPrcnt}} %
            </div>
          </div>
          <div class="progress" *ngIf="row.CloPrcnt <= 100 && row.CloPrcnt > 75">
            <div class="progress-bar" style="width: 100%;background-color: rgb(92, 190, 87);" [style]="'width: '+row.CloPrcnt+'%'">
              {{row.CloPrcnt}} %
            </div>
          </div>

      </ng-template>

      <ng-template #frmSlpCode let-row let-rowIndex="rowIndex">
          <div *ngFor="let item of listaVendedor">
            <div *ngIf="item.SlpCode == row.SlpCode">
              {{item.SlpName}}
            </div>
          </div>
      </ng-template>

      <ng-template #frmStepLast let-row let-rowIndex="rowIndex">
        <select [(ngModel)]="row.StepLast" (change)="actualizaOportunidad(row)" style="padding: 3px;background: #454E55;border-color: #454E55;">
          <option *ngFor="let item of Etapas" [value]="item.StepId">{{item.Descript}}</option>
        </select>
      </ng-template>

      <ng-template #frmMaxSumLoc let-row let-rowIndex="rowIndex">
          {{ row.RealSumLoc | iNDCLP}}
      </ng-template>

      <ng-template #frmOpprId let-row let-rowIndex="rowIndex">
        <div style="cursor: pointer;" (click)="irADocLink(row.DocEntry,row.DocType)">
          <ng-container *ngIf="row.DocNum">
            {{ row.DocNum }}
          </ng-container>
          
          <o style="color: #90c940;">
  
            <ng-container *ngIf="row.DocType == 13">
              FAC
            </ng-container>
  
            <ng-container *ngIf="row.DocType == 17">
              NV
            </ng-container>
  
            <ng-container *ngIf="row.DocType == 23">
              COT
            </ng-container>
  
          </o>
        </div>
        
      </ng-template>

      <ng-template #frmName let-row let-rowIndex="rowIndex">
          {{ row.Name}}
      </ng-template>

      <ng-template #frmCardName let-row let-rowIndex="rowIndex">
          {{ row.CardName}}
      </ng-template>

      <ng-template #frmCategorias let-row let-rowIndex="rowIndex">
          <div *ngFor="let item of row.CATEGORIAS">
            <p style="margin-bottom: 0px;">{{item.ItmsGrpNam}}</p>
          </div>
      </ng-template>

    </mat-tab>

    <mat-tab>

      <ng-template mat-tab-label>
        <i style="font-size: 25px;" class="fa-duotone fa-grip"></i>
      </ng-template>

      <div cdkDropListGroup class="drop-container">
        <div class="example-container scroll-container" #scrollContainer *ngFor="let item of EtapasView">
          <div class="example-container-box" [ngClass]="{'NoSeConcreta': item.StepId == 8}">
            {{ item.Descript }}  {{item.CloPrcnt}} %
            <br>

            {{item.totalOportunidades | iNDCLP}}
            <br>
          </div>

          <div
            cdkDropList
            [cdkDropListData]="item.oportunidades"
            class="example-list"
            (cdkDropListDropped)="drop($event, item)">
            <div class="example-box" style="background: #cccccc;" *ngIf="item.oportunidades.length < 1">
              Sin oportunidades asignadas
              <br>
            </div>
            <div class="example-box" *ngFor="let oport of item.oportunidades" cdkDrag style="font-size: 17px;" (click)="abrirOportunidad(null,oport.OpprId)">

              {{ oport.CardName }}

              <br>

              <ng-container *ngIf="oport.DocNum">
                {{ 'N° ' + oport.DocNum }}

              </ng-container>
              
              <o style="color: #90c940;">

                <ng-container *ngIf="oport.DocType == 13">
                  FAC
                </ng-container>

                <ng-container *ngIf="oport.DocType == 17">
                  NV
                </ng-container>

                <ng-container *ngIf="oport.DocType == 23">
                  COT
                </ng-container>

              </o>
                
                
              {{' - ' + oport.Name }}

              <br>

              {{ oport.MaxSumLoc | iNDCLP }}

              <br>

              {{ oport.PredDate | date:'dd/MM/yyyy'}}



            </div>
          </div>
        </div>
      </div>

    </mat-tab>

  </mat-tab-group>
